var _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _defs3, _clipPath3, _path3, _defs4, _clipPath4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M22 10H12v4h6c-1 2-3 4-6 4s-6-3-6-6 3-6 6-6l4 1 3-2c-2-2-4-3-7-3C7 2 2 6 2 12s5 10 10 10 10-4 10-10z"
}))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc05",
  d: "M1 18V6l8 6z",
  clipPath: "url(#b)"
})), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M22 10H12v4h6c-1 2-3 4-6 4s-6-3-6-6 3-6 6-6l4 1 3-2c-2-2-4-3-7-3C7 2 2 6 2 12s5 10 10 10 10-4 10-10z"
}))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "m1 6 8 6 3-3 11-1V1H1z",
  clipPath: "url(#d)"
})), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M22 10H12v4h6c-1 2-3 4-6 4s-6-3-6-6 3-6 6-6l4 1 3-2c-2-2-4-3-7-3C7 2 2 6 2 12s5 10 10 10 10-4 10-10z"
}))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e",
  overflow: "visible"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M1 18 15 7l4 1 4-7v22H1z",
  clipPath: "url(#f)"
})), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M22 10H12v4h6c-1 2-3 4-6 4s-6-3-6-6 3-6 6-6l4 1 3-2c-2-2-4-3-7-3C7 2 2 6 2 12s5 10 10 10 10-4 10-10z"
}))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g",
  overflow: "visible"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M23 23 9 12l-2-1 16-5z",
  clipPath: "url(#h)"
})));
export default SvgGoogleColored;